import { useQuery } from "@tanstack/react-query";

import { getPaymentLinkData } from "../../services/paymentLinks";
import { PaymentDataResponse } from "../../types/paymentLink";

export const usePaymentLinkData = ({ linkId }: { linkId?: string }) => {
  const {
    data: paymentLinkData,
    isLoading: isPaymentLinkDataLoading,
    isError: isPaymentLinkDataHasError,
  } = useQuery<PaymentDataResponse>({
    queryKey: ["PaymentLinkData", linkId],
    queryFn: async () => await getPaymentLinkData(linkId),
    enabled: !!linkId,
  });

  return { paymentLinkData, isPaymentLinkDataLoading, isPaymentLinkDataHasError };
};
